import { createUserEmailChangeConfirmationQuery } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useUserEmailChangeConfirmationQuery = createUserEmailChangeConfirmationQuery(HTTP_CONFIG.API.Consumer.url)
